import { render, staticRenderFns } from "./projectOverview.vue?vue&type=template&id=c9524c24&scoped=true&"
import script from "./projectOverview.vue?vue&type=script&lang=js&"
export * from "./projectOverview.vue?vue&type=script&lang=js&"
import style0 from "./projectOverview.vue?vue&type=style&index=0&id=c9524c24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9524c24",
  null
  
)

export default component.exports